import Input from './Input.react';

class InputDate extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            uuid : this.props.id || uuid()
        };

        this.onBlur = this.onBlur.bind(this);
    }

    onBlur() {
        const { value: date } = this.props;

        if (!moment(date).isValid())
            $('#'+this.state.uuid).addClass('input-text-1__error');
        else {
            $('#'+this.state.uuid).removeClass('input-text-1__error');
        }
    }

    render() {
        var self = this,
            type = this.props.type || 'date',
            id   = this.state.uuid,
            className = this.props.className || '',
            tabindex = this.props.tabindex || '';

        return (
            <Input
                type={type}
                value={this.props.value}
                disabled={this.props.disabled}
                required={this.props.required}
                className={'input '+className}
                onBlur={this.onBlur}
                id={id}
                onChange={val => { this.props.onChange(val); }}
                placeholder='MM/DD/YYYY'
                tabindex={tabindex} />
        );
    }
}

export default InputDate;



// WEBPACK FOOTER //
// ./ui_src/app/components/form/input/InputDate.react.jsx